export interface StockForecastingOptions {
  search: string;
  productId: string;
  monthsToAnalyse: number;
  showAllDetails: boolean;
  minimumStockCalculation: string;
  ignorePurchaseOrders: boolean;
  monthToStart: string;
}
